import request from "@/service";

/* 日志列表 */
export function getLogPage(data) {
  return request({
    url: "/sys/sys/log/page",
    method: "get",
    params: data
  });
}
/* 三方日志分页-clc */
export function getLogThirdPage(data) {
  return request({
    url: "/sys/sys/log/thirdPage",
    method: "get",
    params: data
  });
}

// 重新同步-clc
export function logResend(data) {
  return request({
    url: `/sys/sys/log/resend`,
    method: "post",
    data
  });
}
